module.exports = __webpack_public_path__ + "static/img/aiIdentify.5aa1bfd5.png";